import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    "q": "How do dermatologists drive more cosmetic volume?",
    "a": "Cosmetic-specific pages and credibility content that separates you from med spas. Patients with budget search for surgeon and dermatologist-led aesthetic care specifically — you just need to show up."
  },
  {
    "q": "Is SEO worth it for medical dermatology?",
    "a": "Yes — 'dermatologist near me', 'acne specialist', and 'skin cancer screening' are huge stable searches. SEO captures patients independent of insurance directories."
  },
  {
    "q": "Should dermatologists run Google Ads?",
    "a": "Yes for cosmetic derm, laser, and injectables — case values justify CPCs. For medical derm, SEO and GBP carry it."
  },
  {
    "q": "Do you market Mohs and skin cancer specifically?",
    "a": "Yes — Mohs and skin cancer screening pages capture an entirely separate, high-urgency patient pipeline."
  },
  {
    "q": "Are HIPAA considerations handled?",
    "a": "Yes — forms, analytics, and ad tracking are configured to respect PHI from day one."
  }
];

export const Route = createFileRoute("/dermatologist-marketing-colorado")({
  head: () =>
    industryMarketingHead("Dermatologist", "dermatology practice", "dermatologist-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry={"Dermatologist"}
      industryLower={"dermatology practice"}
      slug={"dermatologist-marketing-colorado"}
      subheadline={"We help Colorado dermatology practices fill the schedule across medical, cosmetic, and surgical derm — without depending on insurance referrals alone."}
      painPoints={["Cosmetic derm volume is below the practice's potential","Patients can't tell you apart from med spas on Google","Insurance directories send price-shoppers, not patients"]}
      serviceDescriptions={{
        seo: "Rank for dermatologist, acne, skin cancer, Mohs, cosmetic derm, and every dermatology service across every Colorado market.",
        googleMaps: "Own 'dermatologist near me' in the Map Pack with medical-credibility signals.",
        webDesign: "Service-specific pages — medical derm, cosmetic, Mohs, pediatric — with provider bios and online booking.",
        ppc: "High-margin Google Ads for cosmetic derm, laser, and injectable searches with strong ROAS.",
        geoAi: "Get cited when patients ask ChatGPT 'best dermatologist in Denver' or 'skin cancer screening near me'.",
        socialMedia: "Provider-led education content that builds authority and converts cosmetic shoppers.",
      }}
      testimonial={{"quote":"Cosmetic derm volume doubled and our new-patient medical schedule fills weeks out. The provider pages convert way above average.","role":"Board-Certified Dermatologist","city":"Denver"}}
      faqs={FAQS}
      cityHubLinks={[{"to":"/colorado-springs","label":"Dermatology marketing in Colorado Springs","description":"Medical and cosmetic derm across the Pikes Peak region."},{"to":"/denver-digital-marketing","label":"Dermatology marketing in Denver","description":"Compete for cosmetic and medical derm patients in Denver."},{"to":"/boulder-digital-marketing","label":"Dermatology marketing in Boulder","description":"Reach Boulder's skin-aware patient base."}]}
    />
  ),
});
